import * as React from 'react';

import Navbar from '@components/layout/navbar';
import NavbarItem from '@components/layout/navbar/navbar-item';

import { withRouter } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';

interface NavbarPageCtrlProps {
  location: any;
  isMobile: boolean;
  artistsCount: number;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
  artistsCount: state.artist.myArtists.length,
});

const NavbarPageCtrl: React.FC<NavbarPageCtrlProps> = ({
  isMobile,
  location,
  artistsCount,
}) => {
  const NAVBAR_ITEMS_NON_EMPTY_ARTISTS = [
    { to: '/dashboard', label: <Translate id="NAVBAR.ITEM.DASHBOARD" /> },
    { to: '/earnings', label: <Translate id="NAVBAR.ITEM.EARNINGS" /> },
    { to: '/analytics', label: <Translate id="NAVBAR.ITEM.ANALYTICS" /> },
    { to: '/catalog', label: <Translate id="NAVBAR.ITEM.CATALOG" /> },
  ];

  const NAVBAR_ITEMS_EMPTY_ARTISTS = [
    { to: '/catalog', label: <Translate id="NAVBAR.ITEM.CATALOG" /> },
  ];

  const isActive = (path: string) => location.pathname.startsWith(path);
  return (
    <Navbar>
      {(artistsCount === 0
        ? NAVBAR_ITEMS_EMPTY_ARTISTS
        : NAVBAR_ITEMS_NON_EMPTY_ARTISTS
      ).map((item, i) => (
        <NavbarItem
          key={i}
          underlineLink
          to={item.to}
          isBig={isMobile}
          isActive={isActive(`${item.to}`)}
        >
          {item.label}
        </NavbarItem>
      ))}
    </Navbar>
  );
};

export default withRouter(connect(mapStateToProps)(NavbarPageCtrl));
